import styled from "styled-components";

const InputError = styled.div`
    color: red;
    font-weight: 400;
    margin: 8px;
    font-size: 12px;
`;

export default InputError;